module.exports = __webpack_public_path__ + "img/Dkterma-1138-655-306.7f2d0a21.jpg";